<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'GIS_LAYERS', url: '/admin/layer' },
    { label: 'CREATE_LAYER' }
  ]"
></breadcrumbs>

<page-header title="CREATE_LAYER"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label">{{ 'NAME' | translate }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="name"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['name'])"
          [ngClass]="{ 'is-danger': hasError('name') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('name')">
        {{ getError('name') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="COLOR">{{
        'COLOR' | translate
      }}</label>
      <color-picker
        (change)="handleFieldChange($event, 'color')"
        name="color"
        [value]="getField(['color'])"
        class="is-small"
      ></color-picker>
      <p class="help is-danger" *ngIf="hasError('color')">
        {{ getError('color') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="CALCULATION">{{
        'CALCULATION' | translate
      }}</label>
      <div class="control">
        <div class="switch">
          <label>
            <input
              [disabled]="false"
              [checked]="getField(['calculation'])"
              (change)="toggle('calculation', $event)"
              class="switch-input"
              name="calculation"
              type="checkbox"
            />
            <div><div></div></div>
          </label>
        </div>
      </div>
      <p class="help is-danger" *ngIf="hasError('calculation')">
        {{ getError('calculation') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="DELIVERY">{{
        'DELIVERY' | translate
      }}</label>
      <div class="control">
        <div class="switch">
          <label>
            <input
              [disabled]="false"
              [checked]="getField(['delivery'])"
              (change)="toggle('delivery', $event)"
              class="switch-input"
              name="delivery"
              type="checkbox"
            />
            <div><div></div></div>
          </label>
        </div>
      </div>
      <p class="help is-danger" *ngIf="hasError('delivery')">
        {{ getError('delivery') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="ACTIVE">{{
        'ACTIVE' | translate
      }}</label>
      <div class="control">
        <div class="switch">
          <label>
            <input
              [disabled]="false"
              [checked]="getField(['active'])"
              (change)="toggle('active', $event)"
              class="switch-input"
              name="active"
              type="checkbox"
            />
            <div><div></div></div>
          </label>
        </div>
      </div>
      <p class="help is-danger" *ngIf="hasError('active')">
        {{ getError('active') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      (click)="onSubmit($event)"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/layer']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
